<script setup lang="ts">
defineProps<{
  pageTitle: string
  stickyPanelTop?: boolean
}>()

const illustration = useTemplateRef('illustration')
const illustrationIsVisible = useElementVisibility(illustration)
</script>

<template>
  <ContentDiv>
    <Breadcrumbs />

    <PageTitle :title="pageTitle" />

    <!-- Each margin is the card's inset (0 below lg, 24px from lg) minus ContentDiv's padding at the same breakpoint, so change them together -->
    <section class="relative flex flex-col bg-white rounded-4xl gap-2xs pb-2xl px-s lg:px-m 2xl:px-0 -mx-s lg:mx-0 xl:-mx-m">
      <div class="absolute z-[4] inset-0 bg-white rounded-4xl" />
      <div ref="illustration" aria-hidden="true" class="hidden min-[1080px]:flex justify-end w-full max-w-screen-xl px-l mx-auto absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[62%] pointer-events-none">
        <div v-if="illustrationIsVisible">
          <slot name="background-illustration" />
        </div>
      </div>
      <StickyContent v-if="stickyPanelTop" aria-hidden="true" class="h-l -mb-l z-[6] pointer-events-none [--padding-top:0rem]">
        <div class="absolute inset-0 bg-blurple-100 dark:bg-blurple-500 -mx-s lg:-mx-m 2xl:mx-0" />
        <div class="absolute inset-0 bg-white -mx-s lg:-mx-m 2xl:mx-0 rounded-4xl rounded-b-none" />
      </StickyContent>
      <StickyContent v-if="$slots['sticky-header']" class="bg-white pt-m rounded-4xl z-10 [--padding-top:0rem]">
        <div class="absolute inset-0 bg-blurple-100 dark:bg-blurple-500 -mx-s lg:-mx-m 2xl:mx-0" />
        <div class="absolute inset-0 bg-white -mx-s lg:-mx-m 2xl:mx-0 rounded-4xl rounded-b-none" />
        <div class="w-full max-w-340 mx-auto relative">
          <slot name="sticky-header" />
        </div>
      </StickyContent>
      <div class="relative w-full max-w-340 mx-auto z-[5]">
        <slot />
      </div>
    </section>
  </ContentDiv>
</template>
